import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
import { createPOVApi, createProductApi, getDeptListApi, getLocationListApi, getLocListApi, getPOVDetailsApi, getProductEditApi, updateProductApi } from "./setup-api";
import AsyncSelect from "react-select/async";
import { min } from "date-fns";

const ProductCreateModal = ({ checkId, onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [multipleGatein, setmultipleGatein] = useState(false);

  const handleDeptDropdownChange = (selectedOptions) => {
    setDeptOptions(selectedOptions);
  };

  const handleLocationDropdownChange = (selectedOptions) => {
    setLocOptions(selectedOptions);
  };
  const modalStyle = {
    overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
    modal: { backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "718px", overflowY: "auto", minHeight: "fit-content" },
  };

  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [duration, setDuration] = useState("");
  useEffect(() => {
    if (checkId != null) {
      getPOVDetails();
    }
  }, []);

  const multiselectCustomStyles = {
    control: (provided) => ({ ...provided, backgroundColor: "#ffffff", borderRadius: "8px", border: "0.7px solid #E5E5E5", padding: "2px", fontWeight: "500", fontSize: "13px", color: "#212129" }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff", color: state.isSelected ? "#fff" : "#333", padding: 10 }),
    multiValue: (provided) => ({ ...provided, backgroundColor: "#F6F7F8", color: "#212129", borderRadius: "5px", padding: "2px 5px" }),
    multiValueLabel: (provided) => ({ ...provided, color: "#212129" }),
    multiValueRemove: (provided) => ({ ...provided, color: "#212129", cursor: "pointer", ":hover": { backgroundColor: "red", color: "white" } }),
  };

  const fetchOptions = (inputValue, callback) => {
    setTimeout(async () => {
      const response = await getDeptListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value), // Ensure value is a string
            label: String(item.label), // Ensure label is a string
          }));
          callback(options); // Pass data to react-select
        }
      }
    }, 1000);
  };

  const fetchLocOptions = (inputValue, callback) => {
    setTimeout(async () => {
      const response = await getLocListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value), // Ensure value is a string
            label: String(item.label), // Ensure label is a string
          }));
          callback(options); // Pass data to react-select
        }
      }
    }, 1000);
  };

  const [validations, setValidations] = useState({
    code: "",
    name: "",
    location: "",
    department: "",
  });

  const getPOVDetails = async () => {
    try {
      const response = await getProductEditApi(checkId);
      if (response.success === true) {
        console.log(response);
        var povDetails = response.product_type;
        console.log(povDetails);
        setCode(povDetails.code ?? "");
        setName(povDetails.name ?? "");
        setLocOptions(povDetails.locations?.map((item) => ({ value: String(item.value), label: String(item.label) })));
        setDeptOptions(povDetails.departments?.map((item) => ({ value: String(item.value), label: String(item.label) })));
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const submitPurposeVisit = async () => {
    const dataBeforeSanitize = {
      code: code,
      name: name,
      locations: locOptions?.filter((item) => item.value !== "").map((item) => item.value),
      departments: deptOptions?.filter((item) => item.value !== "").map((item) => item.value),
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (checkId == null) {
      const response = await createProductApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          onSuccess(response.data);
          onCancel();
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            locations: "",
            departments: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateProductApi(dataAfterSanitize, checkId);
      if (response.status === 200) {
        if (response.data.success === true) {
          onSuccess(response.data);
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            locations: "",
            departments: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };

  const [lastKey, setLastKey] = useState("");
  const handleChange = (event) => {
    const inputText = event.target.value;
    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
      console.log(event.key);
      if (lastKey === "Backspace") {
        setDuration(inputText);
      } else {
        setDuration(inputText.length === 2 ? inputText + ":" : inputText);
      }
    }
  };
  const [deptOptions, setDeptOptions] = useState(null);
  const [locOptions, setLocOptions] = useState(null);

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div className="modal-header style-justify-between">
            <div className="add-item-modal-title">{checkId != null ? "Edit " : "Add "} Product Type</div>
            <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
          </div>
          <div style={{ padding: "16px 24px" }}>
            <Row style={{ width: "670px" }}>
              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">
                  Code<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={code} onChange={(e) => setCode(e.target.value)} />
                <span className="field-error">{validations.code}</span>
              </Col>

              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">
                  Product Name<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={name} onChange={(e) => setName(e.target.value)} />
                <span className="field-error">{validations.name}</span>
              </Col>

              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">
                  Location
                </div>
                <AsyncSelect
                  isMulti
                  cacheOptions
                  value={locOptions}
                  loadOptions={fetchLocOptions}
                  onChange={(selectedOptions) => {
                    handleLocationDropdownChange(selectedOptions);
                  }}
                  defaultOptions
                  placeholder="Search locations..."
                  styles={multiselectCustomStyles}
                  isClearable={false}
                />
                <span className="field-error">{validations.locations}</span>
              </Col>

              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">
                  Department
                </div>
                <AsyncSelect
                  isMulti
                  cacheOptions
                  value={deptOptions}
                  loadOptions={fetchOptions}
                  onChange={(selectedOptions) => {
                    handleDeptDropdownChange(selectedOptions);
                  }}
                  defaultOptions
                  placeholder="Search departments..."
                  styles={multiselectCustomStyles}
                  isClearable={false}
                />
                <span className="field-error">{validations.departments}</span>
              </Col>
            </Row>

            <Row className="mt-3" style={{ width: "670px" }}>
              <div className="style-justify-end">
                <div onClick={onCancel} className="cancel-modal-btn style-justify-center">
                  Cancel
                </div>
                <div className="save-modal-btn style-justify-center" onClick={submitPurposeVisit}>
                  {checkId != null ? "Update " : "Save "}
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCreateModal;
